export function getZoneName(zone, charniereName) {
  if (!charniereName) return zone.displayName
  return zone.charnieres[charniereName] + zone.displayName
}
